module.exports = __webpack_public_path__ + "img/change.529b8588.svg";